(() => {
  const inquirySelector = '[data-ow-inquiry]';

  function sendInquiryEvent(link) {
    const eventData = {
      inquiry_channel: link.dataset.owInquiry || 'unknown',
      inquiry_location: link.dataset.owInquiryLocation || 'unknown',
      product_title: link.dataset.owProductTitle || '',
      page_path: window.location.pathname,
      link_text: link.textContent.trim().slice(0, 80),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ow_inquiry_click', ...eventData });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', {
        currency: 'USD',
        value: 1,
        method: eventData.inquiry_channel,
        content_name: eventData.product_title || document.title,
        inquiry_location: eventData.inquiry_location,
      });
      window.gtag('event', 'ow_inquiry_click', eventData);
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest(inquirySelector);
    if (!link) return;
    sendInquiryEvent(link);
  });
})();
